import { Component } from '@angular/core';

@Component({
  selector: 'tlc-churn-flow-tellent-logo',
  templateUrl: './churn-flow-tellent-logo.component.html',
  standalone: true,
})
export class ChurnFlowTellentLogoComponent {}
